import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { StoreDetails } from '../../../models/store/StoreDetails';
import { StoreDefaultWorkingTimeAdapter } from './StoreDefaultWorkingTimeAdapter';
import { StoreEmployeeRequirementAdapter } from './StoreEmployeeRequirementAdapter';
import { BankingSettingsAdapter } from './BankingSettingsAdapter';
import { StoreClosureAdapter } from './StoreClosureAdapter';
import { StoreDetailsResponse } from '../../../../interfaces/response/StoreResponses';
import { StoreSpecialWorkingTimeAdapter } from './StoreSpecialWorkingTimeAdapter';

/**
 * An adapter converts store details HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class StoreDetailsAdapter implements Adapter<StoreDetails> {

  /**
   * Converts store details HTTP response to {@link StoreDetails}.
   * @param item store details HTTP response.
   */
  adapt(item: StoreDetailsResponse): StoreDetails {
    const workingTimeAdapter = new StoreDefaultWorkingTimeAdapter();
    const specialWorkingTimesAdapter = new StoreSpecialWorkingTimeAdapter();
    const requirementAdapter = new StoreEmployeeRequirementAdapter();
    const bankingSettingsAdapter = new BankingSettingsAdapter();
    const storeClosureAdapter = new StoreClosureAdapter();
    return new StoreDetails(
      item.slug,
      item.name,
      item.firstEditableDate,
      workingTimeAdapter.adapt(item.defaultWorkingHours),
      specialWorkingTimesAdapter.adapt(item.specialWorkingHours),
      requirementAdapter.adapt(item.employeeRequirements),
      bankingSettingsAdapter.adapt(item.bankingSettings),
      storeClosureAdapter.adapt(item.closures)
    );
  }
}
